// extracted by mini-css-extract-plugin
export default {"card_holder":"PromotionCardGroupMobile_card_holder__lVwJD","price_holder":"PromotionCardGroupMobile_price_holder__OmbDQ"};